import React, { useState } from "react";
import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Button,
    Input,
    InputGroup,
    InputRightElement,
    Stack,
    useDisclosure,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FiRotateCcw, FiList } from "react-icons/fi";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import OutcomeModal from "./OutcomeModal";
import ConfirmationModal from "./ConfirmationModal";

const PAGE_SIZE = 5;

const outcomesData = [
    {
        game: "Tulane Green Wave VS Duke Blue Devils",
        date: "2025-09-14 12:00 AM",
        market: "Spreads",
        totalBets: 1,
        options: [
            { name: "Duke Blue Devils", rate: "1.91", betCount: 0 },
            { name: "Tulane Green Wave", rate: "1.91", betCount: 1 },
        ]
    },
    {
        game: "New Mexico State Aggies VS Tulsa Golden Hurricane",
        date: "2025-09-07 01:00 AM",
        market: "Head to Head",
        totalBets: 2,
        options: [
            { name: "New Mexico State Aggies", rate: "2.50", betCount: 1 },
            { name: "Tulsa Golden Hurricane", rate: "1.55", betCount: 1 },
        ]
    },
    {
        game: "Real Betis VS Real Sociedad",
        date: "2025-09-21 07:00 PM",
        market: "Head to Head",
        totalBets: 1,
        options: [
            { name: "Real Betis", rate: "2.10", betCount: 0 },
            { name: "Real Sociedad", rate: "3.40", betCount: 1 },
            { name: "Draw", rate: "3.20", betCount: 0 },
        ]
    },
    {
        game: "Girona VS Levante",
        date: "2025-09-21 07:00 PM",
        market: "Head to Head",
        totalBets: 1,
        options: [
            { name: "Girona", rate: "1.80", betCount: 1 },
            { name: "Levante", rate: "4.20", betCount: 0 },
            { name: "Draw", rate: "3.50", betCount: 0 },
        ]
    },
    {
        game: "Barcelona VS Getafe",
        date: "2025-09-21 07:00 PM",
        market: "Totals",
        totalBets: 1,
        options: [
            { name: "Over 2.5", rate: "1.90", betCount: 1 },
            { name: "Under 2.5", rate: "1.90", betCount: 0 },
        ]
    },
    {
        game: "Barcelona VS Getafe",
        date: "2025-09-21 07:00 PM",
        market: "Head to Head 3 way",
        totalBets: 1,
        options: [
            { name: "Barcelona", rate: "1.40", betCount: 1 },
            { name: "Getafe", rate: "7.50", betCount: 0 },
            { name: "Draw", rate: "4.80", betCount: 0 },
        ]
    },
];

export default function PendingOutcomes() {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const {
        isOpen: isOutcomeOpen,
        onOpen: onOutcomeOpen,
        onClose: onOutcomeClose
    } = useDisclosure();
    const {
        isOpen: isRefundOpen,
        onOpen: onRefundOpen,
        onClose: onRefundClose
    } = useDisclosure();

    const [selectedMarket, setSelectedMarket] = useState({ name: "", options: [] });

    const filtered = outcomesData.filter((o) =>
        o.game.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const start = (page - 1) * PAGE_SIZE;
    const data = filtered.slice(start, start + PAGE_SIZE);
    const SIDEBAR_WIDTH = "240px";

    const handleSelectOutcome = (item) => {
        setSelectedMarket({ name: item.market, options: item.options || [] });
        onOutcomeOpen();
    };

    const handleRefundConfirm = () => {
        console.log("Refunded bet amount for market");
        onRefundClose();
    };

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={6}
                bg="gray.50"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex
                    mb={4}
                    justify="space-between"
                    align={{ base: "stretch", md: "center" }}
                    direction={{ base: "column", md: "row" }}
                    gap={3}
                >
                    <Text fontSize="xl" fontWeight="bold">
                        Pending Outcomes
                    </Text>

                    <InputGroup maxW={{ base: "100%", md: "260px" }}>
                        <Input
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            bg="white"
                        />
                        <InputRightElement bg="#4f46e5" color="white" borderRadius="0 5px 5px 0" cursor="pointer">
                            <SearchIcon />
                        </InputRightElement>
                    </InputGroup>
                </Flex>

                {/* DESKTOP TABLE */}
                <Box display={{ base: "none", md: "block" }} bg="white" borderRadius="md" overflow="hidden" boxShadow="sm">
                    <Table>
                        <Thead bg="#4f46e5">
                            <Tr>
                                <Th color="white" py={4}>Game</Th>
                                <Th color="white" py={4}>Market</Th>
                                <Th color="white" py={4}>Total Bets</Th>
                                <Th color="white" py={4} textAlign="right">
                                    Action
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.map((o, i) => (
                                <Tr key={i}>
                                    <Td>
                                        <Text fontWeight="600" color="gray.700">{o.game}</Text>
                                        <Text fontSize="sm" color="gray.500">
                                            {o.date}
                                        </Text>
                                    </Td>
                                    <Td>{o.market}</Td>
                                    <Td>{o.totalBets}</Td>
                                    <Td>
                                        <Flex justify="flex-end" gap={2}>
                                            <Button
                                                size="sm"
                                                variant="outline"
                                                colorScheme="blue"
                                                leftIcon={<MdOutlineRadioButtonChecked />}
                                                onClick={() => handleSelectOutcome(o)}
                                            >
                                                Select Outcome
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="outline"
                                                colorScheme="cyan"
                                                leftIcon={<FiRotateCcw />}
                                                onClick={onRefundOpen}
                                            >
                                                Refund Bet
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="outline"
                                                colorScheme="gray"
                                                leftIcon={<FiList />}
                                            >
                                                Bets
                                            </Button>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Box>

                {/* MOBILE CARD VIEW */}
                <Stack spacing={3} display={{ base: "block", md: "none" }}>
                    {data.map((o, i) => (
                        <Box key={i} p={4} bg="white" boxShadow="sm" borderRadius="md">
                            <Text fontWeight="bold">{o.game}</Text>
                            <Text fontSize="sm" color="gray.500">
                                {o.date}
                            </Text>

                            <Flex mt={2} justify="space-between">
                                <Text>Market:</Text>
                                <Text fontWeight="medium">{o.market}</Text>
                            </Flex>

                            <Flex mt={1} justify="space-between">
                                <Text>Total Bets:</Text>
                                <Text fontWeight="medium">{o.totalBets}</Text>
                            </Flex>

                            <Stack mt={3}>
                                <Button
                                    size="sm"
                                    variant="outline"
                                    colorScheme="blue"
                                    leftIcon={<MdOutlineRadioButtonChecked />}
                                    onClick={() => handleSelectOutcome(o)}
                                >
                                    Select Outcome
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline"
                                    colorScheme="cyan"
                                    leftIcon={<FiRotateCcw />}
                                    onClick={onRefundOpen}
                                >
                                    Refund Bet
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline"
                                    colorScheme="gray"
                                    leftIcon={<FiList />}
                                >
                                    Bets
                                </Button>
                            </Stack>
                        </Box>
                    ))}
                </Stack>

                {/* PAGINATION */}
                <Flex justify="center" mt={6} gap={3}>
                    <Button
                        size="sm"
                        onClick={() => setPage((p) => Math.max(p - 1, 1))}
                        isDisabled={page === 1}
                    >
                        Prev
                    </Button>
                    <Text fontSize="sm" alignSelf="center">
                        Page {page} of {totalPages}
                    </Text>
                    <Button
                        size="sm"
                        onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                        isDisabled={page === totalPages}
                    >
                        Next
                    </Button>
                </Flex>
            </Box>

            <OutcomeModal
                isOpen={isOutcomeOpen}
                onClose={onOutcomeClose}
                marketName={selectedMarket.name}
                outcomes={selectedMarket.options}
            />

            <ConfirmationModal
                isOpen={isRefundOpen}
                onClose={onRefundClose}
                onConfirm={handleRefundConfirm}
                message="Do you want to return the bet amount for this market?"
            />
        </>
    );
}
